export type ErrorDisplay = 'complete' | 'base' | 'page';
